module.exports = __webpack_public_path__ + "img/notification.10b6ad98.svg";